export class DialogEventArgs {
  title: string = '';
  message: string = '';
  acceptText: string = 'Ok';
  width: number = 500;
  declineText: string | null = null;

  constructor(init?: Partial<DialogEventArgs>) {
    Object.assign(this, init);
  }

  acceptAction: () => void = () => {
    return true;
  };
}
